import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { baseRelatedPspBranchesSelectors, BaseCoreState, PspResponse, SurchargeListItemResponse } from 'base';

@Component({
  selector: 'base-customer-provider-details-employee-lease',
  templateUrl: './base-customer-provider-details-employee-lease.component.html',
})
export class BaseCustomerProviderDetailsEmployeeLeaseComponent implements OnInit, OnDestroy {
  surcharges: SurchargeListItemResponse[] = [];
  cancellationPeriod: number;

  private destroy$ = new Subject();

  constructor(private store: Store<BaseCoreState>) {}

  ngOnInit(): void {
    combineLatest([
      this.store.select(baseRelatedPspBranchesSelectors.getRelatedPspBranchSurcharges),
      this.store.select(baseRelatedPspBranchesSelectors.getRelatedPspBranchData),
    ])
      .pipe(
        takeUntil(this.destroy$),
        filter(([surchargesState, branchDataState]) => !!surchargesState.ok && !!branchDataState.ok),
        map(([surcharges, branchData]) => [surcharges.data, branchData.data])
      )
      .subscribe(([surcharges, branchData]) => {
        this.surcharges = surcharges as SurchargeListItemResponse[];
        this.cancellationPeriod = (branchData as PspResponse)?.cancellationPeriod as number;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
